import ReconciliationItemBase from './base/ReconciliationItemBase';

/**
 * @class ReconciliationItem
 * @extends ReconciliationItemBase
 */
class ReconciliationItem extends ReconciliationItemBase {

}

export default ReconciliationItem;
